import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const ChefHat = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <g>
        <path
          fill={props.color || theme.palette.grey600}
          fillRule="evenodd"
          d={
            props.variant === "line"
              ? "M12 4c1.155 0 2.224.498 2.97 1.332l.101.118.107-.027a3.86 3.86 0 01.615-.084L16 5.333a4 4 0 014 4 3.994 3.994 0 01-1.781 3.325l-.219.135v3.874a.667.667 0 01-.589.662l-.078.004a.667.667 0 01-.662-.589l-.004-.077v-4.282c0-.264.156-.504.399-.61A2.665 2.665 0 0016 6.667c-.316 0-.632.062-.949.183a.667.667 0 01-.801-.267A2.656 2.656 0 0012 5.333c-.922 0-1.762.477-2.25 1.25a.667.667 0 01-.801.267A2.644 2.644 0 008 6.667a2.665 2.665 0 00-1.066 5.108.667.667 0 01.394.523l.005.087v4.282a.667.667 0 01-1.329.077L6 16.667v-3.874l-.033-.018a3.996 3.996 0 01-1.964-3.276L4 9.333a4 4 0 014-4c.277 0 .551.031.822.09l.106.027.102-.118a3.978 3.978 0 012.797-1.328L12 4zm5.333 14.667a.667.667 0 01.078 1.328l-.078.005H6.667a.667.667 0 01-.078-1.329l.078-.004h10.666zm-7.337-6.078a.667.667 0 00-1.33.078V16l.005.078A.667.667 0 0010 16v-3.333l-.004-.078zM12 12c.342 0 .624.257.662.589l.005.078V16a.667.667 0 01-1.33.078L11.334 16v-3.333c0-.368.299-.667.667-.667zm3.329.589a.667.667 0 00-1.329.078V16l.005.078A.667.667 0 0015.332 16v-3.333l-.004-.078z"
              : "M11.077 1.445A4.01 4.01 0 0112 1.333a4 4 0 014 4c0 1.48-.805 2.769-2 3.461v3.873h-2V10a.667.667 0 00-1.333 0v2.667h-2V10a.667.667 0 00-1.334 0v2.667h-2V10A.667.667 0 004 10v2.667H2V8.794a3.995 3.995 0 01-2-3.46 4 4 0 014-4c.319 0 .627.04.923.11A3.99 3.99 0 018 0a3.99 3.99 0 013.077 1.445zM14 14v2H2v-2h12z"
          }
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

export { ChefHat };
